export const datatable = {
  page: 'Strona',
  outOf: 'z',
  countSize: 'Liczba rekordów na stronę',
  showing: 'Wyświetlanie',
  showingCont: 'rekordów z',
  choose: 'Wybierz',
  notFoundField: 'Nie znaleziono pola',
  searchPlaceholder: 'Znajdź krok',
}
